<mat-form-field [color]="color" [appearance]="appearance" [floatLabel]="floatLabel">
  @if (label) {
    <mat-label>{{label}}</mat-label>
  }
  <mat-select
    [multiple]="multiple"
    [formControl]="control"
    [compareWith]="compareById"
    [placeholder]="placeholder"
    [required]="required"
    panelClass="filter-select-panel filter-select-panel--search"
    [matTooltip]="tooltip()"
    [matTooltipClass]="'field-tooltip'"
    [matTooltipPosition]="toolTipPosition"
    (selectionChange)="onSelectionChange()">
    <mat-select-trigger>{{ summary() }}</mat-select-trigger>

    <mat-option>
      <ngx-mat-select-search
        placeholderLabel="Search"
        noEntriesFoundLabel="No Aliases Found"
        [id]="'filter-' + controlName"
        [formControl]="filterControl"
        [showToggleAllCheckbox]="multiple"
        [toggleAllCheckboxChecked]="allToggled()"
        [toggleAllCheckboxIndeterminate]="indeterminate()"
        (toggleAll)="onToggleAll($event)"></ngx-mat-select-search>
    </mat-option>

    @for (option of filteredOptions; track option.ID) {
      <mat-option
        [value]="option"
        [disabled]="isOtherPayers(option)"
        [class.payer-alias-filter-select__option--current]="isCurrentPayers(option)"
        [matTooltip]="getOptionTooltip(option)"
        [matTooltipClass]="'field-tooltip'"
        [matTooltipPosition]="'left'">
        {{option.Name}}
      </mat-option>
    }
  </mat-select>

  @if (control.hasError('required')) {
    <mat-error>Selection is <strong>required</strong></mat-error>
  }
</mat-form-field>
